export default class DeleteProposalRecordError extends Error {
}
